import React, { useMemo, useRef, useState } from "react";
import { motion } from "framer-motion";

import {
  copyIcon,
  exportIcon,
  filterIcon,
  searchIcon,
} from "../../../Base/SVG";
import Dropdown from "../../../Base/Dropdown";
import { TableModul } from "./TableModul";
import { Pagination } from "./Pagination";
import { txLinkUrl, webBaseURL } from "../../../utils/config";
import { Link } from "react-router-dom";
import { CSVLink } from "react-csv";
import { csvHeader, networkIcons, tokenIcons } from "../../../utils/constants";
export default function InvoiceTable({
  setModal,
  setModalData,
  historyList,
  selectedStatus,
  setSelectedStatus,
  offset,
  setOffset,
}) {
  const [activeList, setActiveList] = useState(TableModul);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  let PageSize = 6;

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return activeList.slice(firstPageIndex, lastPageIndex);
  }, [currentPage]);

  // const filteredData = () => {
  //   if (searchText === "") return historyList?.list;
  //   debugger
  //   return historyList?.list?.filter((his) => his.amountUsd === searchText);
  // };

  const filteredData = () => {
    if (!searchText) {
      return historyList?.list;
    }

    const formattedSearchText = searchText.trim().toLowerCase();

    return historyList?.list?.filter((his) => {
      const formattedAmountUsd = his.amountUsd.toLowerCase();
      const formattedNetworkId = his.payment?.networkId?.toLowerCase();
      const formattedTokenName = his.payment?.token?.name?.toLowerCase();
      const formattedStatus = his.status?.toLowerCase();

      return (
        formattedAmountUsd.includes(formattedSearchText) ||
        (formattedNetworkId &&
          formattedNetworkId.includes(formattedSearchText)) ||
        (formattedTokenName &&
          formattedTokenName.includes(formattedSearchText)) ||
        (formattedStatus && formattedStatus.includes(formattedSearchText))
      );
    });
  };

  return (
    <div className="invoiceTable box">
      <div className="invoiceTable__header">
        <div className="search">
          <input
            value={searchText}
            type="text"
            placeholder="Search for transaction here"
            onChange={(e) => setSearchText(e.target.value)}
          />
          <button className="button" type="button">
            {searchIcon}
          </button>
        </div>
        <div className="invoiceTable__header-action">
          <Dropdown btnInner={<>{filterIcon} Filter</>}>
            <div
              onClick={() => setSelectedStatus(null)}
              className="dropdown__menu-link"
            >
              All
            </div>
            <div
              onClick={() => setSelectedStatus("New")}
              className="dropdown__menu-link"
            >
              New
            </div>
            <div
              onClick={() => setSelectedStatus("Paid")}
              className="dropdown__menu-link"
            >
              Paid
            </div>
            <div
              onClick={() => setSelectedStatus("Expired")}
              className="dropdown__menu-link"
            >
              Expired
            </div>
          </Dropdown>
          {historyList?.list?.length ? (
            <CSVLink
              className="button export"
              data={historyList?.list}
              headers={csvHeader}
              filename="Invoice-History.csv"
              target="_blank"
            >
              {exportIcon} Export
            </CSVLink>
          ) : (
            <button
              style={{ cursor: "not-allowed", backgroundColor: "#ccc" }}
              className="button export"
            >
              {exportIcon} Export
            </button>
          )}
        </div>
      </div>
      <div className="invoiceTable__body">
        <table>
          <thead>
            <tr>
              <th>Amount</th>
              <th>Token</th>
              <th>Blockchain</th>
              <th>Creation Date</th>
              <th>Expiry Date</th>
              <th>Payment Date</th>
              <th>Status</th>
              <th>NFT Link</th>
              <th>Tx Link</th>
              <th>Invoice Link</th>
            </tr>
          </thead>
          <tbody>
            {/* {currentTableData.map((item, index) => {
              return (
                <TableRow
                  key={index}
                  {...item}
                  onClick={() => {
                    setModal("details");
                    setModalData(item);
                  }}
                />
              );
            })} */}

            {filteredData()?.map((item, index) => {
              return (
                <TableRow
                  key={index}
                  {...item}
                  onClick={() => {
                    setModal("details");
                    setModalData(item);
                  }}
                />
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="invoiceTable__footer">
        <Pagination
          currentPage={currentPage}
          totalCount={historyList?.total ?? 6}
          pageSize={PageSize}
          offset={offset}
          onPageChange={(page) => setCurrentPage(page)}
          setOffset={(off) => setOffset(off)}
        />
      </div>
    </div>
  );
}
const TableRow = (props) => {
  const [copied, setCopied] = useState(null);
  const refBtn1 = useRef(null);
  const refBtn2 = useRef(null);
  const refBtn3 = useRef(null);
  const clickFunc = (e) => {
    if (
      !refBtn1.current.contains(e.target) &&
      !refBtn2.current.contains(e.target) &&
      !refBtn3.current.contains(e.target)
    )
      props.onClick();
  };
  // const copyBtn = (data, id, type) => {
  //   navigator.clipboard.writeText(data);
  //   setCopied({ id: id, type: type });
  //   setTimeout(() => {
  //     setCopied(null);
  //   }, 1000);
  // };
  const copyBtn = async (data, id, type) => {
    try {
      await navigator.clipboard.writeText(data);
      setCopied({ id: id, type: type });
      setTimeout(() => {
        setCopied(null);
      }, 1000);
    } catch (error) {
      console.error("Failed to copy text:", error);
    }
  };
  const renderDate = (date) => {
    return `
      ${new Date(date).getDate()} / ${
      new Date(date).getMonth() + 1
    } / ${new Date(date).getFullYear()}
    `;
  };
  function truncateString(str, startNumber = 4) {
    if (!str) return null;
    if (str.length <= 6) {
      return str; // Return the whole string if it's 6 characters or less
    } else {
      const truncated =
        str.substring(0, startNumber) + "..." + str.slice(-startNumber);
      return truncated;
    }
  }

  return (
    <motion.tr
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
      exit={{ opacity: 0 }}
      onClick={clickFunc}
    >
      <td>$ {Number(props?.amountUsd).toFixed(2)}</td>
      <td>
        <div className="invoiceTable__row">
          {props?.payment?.token?.name && (
            <img
              src={
                process.env.PUBLIC_URL + tokenIcons[props?.payment?.token?.name]
              }
              alt="coin"
            />
          )}
          {props?.payment?.token?.name ?? "-"}
        </div>
      </td>

      <td>
        <div className="invoiceTable__row">
          {props?.payment?.networkId && (
            <img
              src={
                process.env.PUBLIC_URL + networkIcons[props?.payment?.networkId]
              }
              alt="coin"
            />
          )}
          {props?.payment?.networkId ?? "-"}
        </div>
      </td>

      <td>{renderDate(props?.createdAt)}</td>
      <td>{renderDate(props?.expiresAt)}</td>
      <td>
        {props?.payment?.timestamp
          ? renderDate(props?.payment?.timestamp)
          : "-"}
      </td>
      <td>
        {props.status === "Paid" && (
          <div className="status active">{props.status}</div>
        )}
        {props.status === "Expired" && (
          <div className="status inActive">{props.status}</div>
        )}
        {props.status === "New" && (
          <div className="status hold">{props.status}</div>
        )}

        {props.status === "Reserved" && (
          <div className="status hold">{props.status}</div>
        )}
      </td>
      <td>
        <div className="link" ref={refBtn1} onClick={() => copyBtn("nftLink")}>
          {truncateString(props?.payment?.nftId)
            ? truncateString(props?.payment?.nftId)
            : "-"}
          {truncateString(props?.payment?.nftId) && copyIcon}
          <span
            className={
              "tooltip " +
              (copied?.id === props.id && copied?.type === "nftLink"
                ? "active"
                : "")
            }
          >
            Copied
          </span>
        </div>
      </td>
      <td>
        <div
          className="link"
          ref={refBtn2}
          onClick={() =>
            copyBtn(`${txLinkUrl}${props?.payment?.hash}`, "txLink")
          }
        >
          <a
            target="_blank"
            className="anc"
            href={`${txLinkUrl}${props?.payment?.hash}`}
          >
            {truncateString(props?.payment?.hash)
              ? truncateString(props?.payment?.hash)
              : "-"}
          </a>

          {truncateString(props?.payment?.hash) && copyIcon}

          <span
            className={
              "tooltip " +
              (copied?.id === props.id && copied?.type === "txLink"
                ? "active"
                : "")
            }
          >
            Copied
          </span>
        </div>
      </td>
      <td>
        <div
          className="link"
          ref={refBtn3}
          onClick={() =>
            copyBtn(`${webBaseURL}/landing?invoice=${props.id}`, "invoiceLink")
          }
        >
          <a
            target="_blank"
            className="anc"
            href={`/landing?invoice=${props.id}`}
          >
            {truncateString(`${webBaseURL}/landing?invoice=${props.id}`, 7)}
          </a>

          {copyIcon}
          <span
            className={
              "tooltip " +
              (copied?.id === props.id && copied?.type === "invoiceLink"
                ? "active"
                : "")
            }
          >
            Copied
          </span>
        </div>
      </td>
    </motion.tr>
  );
};
// {currentTableData.map((item, index) => {
//   return (
//     <NoticeItem
//       key={index}
//       {...item}
//       onClick={() => {
//         setTab("detail");
//         setItemIndex(index);
//       }}
//     />
//   );
// })}
// </div>
